import globalConfig from './config';
import { isExternalSdk } from './environment-utils';
import { isDisabledOn, isEnabledOn } from './features-enabling-utils';

// anything added to this list HAS TO be tested
const getFeatures = () => ({
  installIcon: isEnabledOn({
    android: { lowerThan: 8 },
    externalSdk: false,
    web: false
  }),

  edgeToEdgeDetection: isEnabledOn({
    ios: false,
    web: false,
    android: { greaterOrEqualTo: 15 },
    androidSdk: { lowerThan: '5.0.0' }
  }),

  saveBrowserInstallIcon: isDisabledOn({
    ios: true,
    externalSdk: true,
    web: true
  }),

  installIconAfterBrowser: isEnabledOn({
    android: { greaterOrEqualTo: 8 },
    androidSdk: { greaterOrEqualTo: '3.2.1' },
    externalSdk: false,
    web: false
  }),

  oguryBrowser: isDisabledOn({ externalSdk: true, web: true }),

  recommendedLinks: isEnabledOn({
    ios: true,
    android: { greaterOrEqualTo: 5 },
    externalSdk: false,
    web: false
  }),

  recommendedLinksScriptInjection: isEnabledOn({
    ios: false,
    android: { greaterOrEqualTo: 5 },
    externalSdk: false,
    web: false
  }),

  contentDiscovery: isEnabledOn({
    ios: true,
    android: { greaterOrEqualTo: 5 },
    externalSdk: false,
    web: false
  }),

  contentDiscoveryScriptInjection: isEnabledOn({
    ios: false,
    android: { greaterOrEqualTo: 5 },
    externalSdk: false,
    web: false
  }),

  androidIntents: isEnabledOn({
    android: true,
    ios: false,
    androidSdk: { greaterOrEqualTo: '1.8.0' },
    externalSdk: false,
    web: false
  }),

  iosDefaultBrowser: isEnabledOn({
    ios: true,
    externalSdk: false,
    web: false
  }),

  rageQuitEvent: isDisabledOn({ externalSdk: true, web: true }),

  clearCloseCallbackAfterClick: isEnabledOn({
    android: true,
    androidSdk: { greaterOrEqualTo: '3.0.0' },
    ios: true,
    externalSdk: false,
    web: false
  }),

  webviewFormatOguryPrecaching: isEnabledOn({
    android: true,
    androidSdk: { greaterOrEqualTo: '3.0.0' },
    ios: true,
    externalSdk: false,
    web: false
  }),

  // video format specific
  videoOverlayThumbnail: isEnabledOn({
    androidSdk: { greaterOrEqualTo: '3.3.0' },
    ios: true,
    externalSdk: false,
    web: true
  }),

  videoForceUseCustomClose:
    isEnabledOn({
      androidSdk: { lowerThan: '3.0.0' },
      web: true
    }) ||
    // allow in external for android and ios even if ios is disable in internal
    isExternalSdk(),

  videoFormatLegacyPlaybackError: isEnabledOn({
    androidSdk: { lowerThan: '3.0.0' },
    web: false
  }),

  videoReward: isEnabledOn({
    android: true,
    androidSdk: { greaterOrEqualTo: '2.2.0' },
    ios: true,
    externalSdk: false,
    web: false
  }),

  injectMraidOnWebview: isEnabledOn({
    android: true,
    ios: true,
    iosSdk: { lowerThan: '2.5.0' },
    externalSdk: true,
    web: true
  }),

  // On the latest iPhone with notch the landing page Y position is too low
  // and overlap the browser navbar which prevent the use to close the Ogury Browser
  // This feature is used to shift the landing page on the Y axis. It will be fixed
  // on SDK side in the latest versions.
  // Fixed in 2.3.3 SDK
  browserLandingPageYShifted: isEnabledOn({
    android: false,
    ios: true,
    iosSdk: { lowerThan: '2.3.3' },
    externalSdk: false,
    web: false
  }),
  skan: isEnabledOn({
    android: false,
    ios: true,
    iosSdk: { greaterOrEqualTo: '3.4.0' },
    externalSdk: false,
    web: false
  }),
  skoverlay: isEnabledOn({
    android: false,
    ios: true,
    iosSdk: { greaterOrEqualTo: '3.5.0' },
    externalSdk: false,
    web: false
  }),
  sdkiOSKeepAlive: isEnabledOn({
    android: false,
    ios: true,
    externalSdk: false,
    web: false
  })
});

const featuresCache = getFeatures();

export function isFeatureEnable(featureName: string): boolean {
  const features =
    globalConfig.NODE_ENV === 'test' ? getFeatures() : featuresCache;
  if (typeof features[featureName as keyof typeof features] === 'undefined') {
    throw new Error(`Feature unknown: ${featureName}`);
  }

  return features[featureName as keyof typeof features];
}
